import { render, staticRenderFns } from "./tCustomerForm.vue?vue&type=template&id=484b7933&scoped=true"
import script from "./tCustomerForm.vue?vue&type=script&lang=js"
export * from "./tCustomerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484b7933",
  null
  
)

export default component.exports